import { produce, Draft } from 'immer';

/**
 * A curried function that takes in a `State` type in the first invocation.
 * The returned function takes in a callback - whose sole parameter is the draft object
 * that will be modified - and will return a curried producer that will receive the `state`
 * from React.
 *
 * @example
 * const stateHandler = buildReactStateHandler<State>();
 *
 * this.setState(stateHandler(draft => {
 *  draft.vips['abc123'].name = 'Kevin';
 * }))
 */
export const buildReactStateHandler = <T extends {}>() => (callback: (draft: Draft<T>) => void) =>
  produce<T>(draft => callback(draft));
